import { createCustomEnum } from "./customEnum";

const PinDebitTypes = createCustomEnum({
	Internal: {
		value: 0,
		name: "Internal",
		displayName: "Internal",
	},
	External: {
		value: 1,
		name: "External",
		displayName: "External",
	},
	None: {
		value: 2,
		name: "None",
		displayName: "None",
	},
});

export default PinDebitTypes;
